module.exports = __webpack_public_path__ + "abf8930e3e72f3ae3fdff2dc5add153b.woff2";